<template>
  <div class="ln-bind-phone">
    <Form ref="form">
      <Field
        v-model="info"
        name="info"
        placeholder="请输入您的11位手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }]"
      >
        <i slot="left-icon" class="iconfont iconphone"></i>
      </Field>
      <check-code v-model="code" :params="codeParams"></check-code>
      <div class="bottom">
        <Row class="login-row" gutter="10">
          <Col span="12"><Button block type="info" @click="closeBind()">关闭</Button></Col>
          <Col span="12"><Button block type="info" @click="next">确认绑定</Button></Col>
        </Row>

        <!-- <AgreeRegister v-model="agree"></AgreeRegister> -->
      </div>
    </Form>
  </div>
</template>

<script>
import { Form, Field, Button, Col, Row } from 'vant';
import { commonMixin } from '@/mixin';
// import AgreeRegister from '@/components/AgreeRegister';
import CheckCode from '@/components/CheckCode';
import channelServer from '@/server/channelServer';
import cookies from '@/cookies';
import { mapState } from 'vuex';
import server from '@/server';
import mixServer from '@/server/mixServer';

export default {
  name: 'ln-bind-phone',
  mixins: [commonMixin],
  components: { Form, Field, Button, Col, Row, CheckCode },
  data() {
    return {
      info: '',
      code: '',
      token: '',
      agree: true,
      bindTimer: null,
    };
  },
  created() {},
  computed: {
    codeParams() {
      return {
        mobile: this.info,
        type: 4 /* 绑定手机 */,
      };
    },
    ...mapState(['componentParams', 'guestLoginData']),
  },
  methods: {
    closeBind() {
      console.log(this.componentParams);
      if (this.componentParams && this.componentParams.force_cert_status == 0 && mixServer.isAntiAddiction == 1) {
        this.$store.commit('SHOW', {
          name: 'CertFront',
          params: { cert_url: this.componentParams.real_name_cert, cert_msg: this.componentParams.cert_msg },
        });
      } else {
        this.$store.commit('CLOSE');
        // server.autoLogin();
        // mixServer.login({ver: server.ver, info:JSON.stringify(this.componentParams)})
        mixServer.login(this.guestLoginData);
      }
      // this.$store.commit('SET_SHOWBIND', 0);
    },
    next() {
      if (this.bindTimer) clearTimeout(this.bindTimer);
      this.bindTimer = setTimeout(() => {
        this.formCheck('form').then(() => {
          const params = {
            info: this.info,
            code: this.code,
            token: cookies.getItem('ln_h5sdk_user_token'),
          };
          channelServer.bindPhone(params).then((data) => {
            this.$store.commit('CLOSE');
            this.$store.commit('SET_SHOWBIND', 0);
            // server.autoLogin();
            if (this.componentParams && this.componentParams.force_cert_status == 0 && mixServer.isAntiAddiction == 1) {
              this.$store.commit('SHOW', {
                name: 'CertFront',
                params: { cert_url: this.componentParams.real_name_cert, cert_msg: this.componentParams.cert_msg },
              });
            } else {
              mixServer.login(this.guestLoginData);
            }
            // this.$store.commit('SHOW', 'Login');
          });
        });
      }, this.$store.state.button_interval);
    },
  },
};
</script>
<style lang="scss">
/* @import url() */
.ln-bind-phone {
}
</style>
